import { useQuery, useMutation, useInfiniteQuery } from "react-query";
import { queryClient } from "../../libs/react-query";
import { addNationality, deleteNationality, editNationality, findNationality, getInfiniteNationality, getNationalities } from "../apiClient/nationality";
import {
  GET_NATIONALITY,
  FIND_NATIONALITY,
  GET_INFINITE_NATIONALITY,
} from "../../constants/queryKeys";

const invalidateFindNationalityQuery = () => {
  queryClient.invalidateQueries(FIND_NATIONALITY);
};
const invalidateNationalityQuery = () => {
  queryClient.invalidateQueries(GET_NATIONALITY);
};
const invalidateNationalityInfiniteQuery = () => {
  queryClient.invalidateQueries(GET_INFINITE_NATIONALITY);
};
const useGetNationalities = ({ payload, config }) => {
  return useQuery([GET_NATIONALITY, payload], () => getNationalities(payload), config);
};
const useInfiniteFetchNationality = ({ payload, config }) => {
  return useInfiniteQuery(
    [GET_INFINITE_NATIONALITY, payload],
    getInfiniteNationality,
    config
  );
};
const useFindNationality = ({ payload, config }) => {
  return useQuery([FIND_NATIONALITY, payload], () => findNationality(payload), config);
};
const useAddNationality = (options) => {
  return useMutation((payload) => addNationality(payload), options);
};
const useEditNationality = (options) => {
  return useMutation((payload) => editNationality(payload), options);
};
const useDeleteNationality = (options) => {
  return useMutation((payload) => deleteNationality(payload), options);
};

export {
    useDeleteNationality,
    useEditNationality,
    useAddNationality,
    useFindNationality,
    useGetNationalities,
    invalidateNationalityQuery,
    invalidateNationalityInfiniteQuery,
    useInfiniteFetchNationality,
    invalidateFindNationalityQuery
};
